import React from 'react';
import { Button, ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import styles from "./SendEmailOnBehalfModal.module.scss";
import { useIoContext, useStore, useStoreActions } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { handleRequest } from "../../infra/utils";
import gmailLogo from "../../../assets/Gmail.png";
import outlookLogo from "../../../assets/Outlook.png";
export function SendEmailOnBehalfModal(_ref) {
  let {
    dismissModal
  } = _ref;
  const businessId = useStore(selectors.user.businessId);
  const {
    api
  } = useStoreActions();
  const changeLocation = useIoContext().changeLocation;
  const {
    startLoader,
    stopLoader,
    showErrorToast
  } = useOverlayContext();
  const {
    logBI
  } = useStoreActions();
  const connectGmail = async () => {
    logBI(18501, {
      vendorId: businessId
    });
    if (businessId) {
      startLoader();
      const result = await handleRequest(api.notification.connectEmailOnBehalf(businessId));
      if (result.success) {
        changeLocation(result.data);
      } else {
        logBI(18503, {
          vendorId: businessId
        });
        showErrorToast('Failed to connect gmail account - please try again', 'start-gmail-flow-error-toast');
      }
      stopLoader();
    } else {
      logBI(18503, {
        vendorId: businessId
      });
      showErrorToast('please refresh and try again', 'no-business-id-error-toast');
    }
  };
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: "Send emails using my own domain",
    "data-testid": "send-email-on-behalf-modal",
    onSecondaryButtonClick: dismissModal,
    onCloseButtonClick: dismissModal,
    content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraph1",
      className: styles.description
    }, "Using your own domain to send emails ensures brand consistency, making your communications more recognizable and trustworthy to clients. It also improves email deliverability, reducing the chances of your emails being marked as spam. ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Please choose an email platform to connect:"), /*#__PURE__*/React.createElement("div", {
      className: styles.buttons
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.MailButton
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.MailButtonImage
    }, /*#__PURE__*/React.createElement("img", {
      src: gmailLogo,
      width: 35,
      height: 35
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, "Gmail")), /*#__PURE__*/React.createElement(Button, {
      size: "small",
      skin: "primaryOutline",
      "data-testid": "connect-gmail-button",
      onClick: connectGmail
    }, "Connect your Gmail account")), /*#__PURE__*/React.createElement("div", {
      className: styles.MailButton
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.MailButtonImage
    }, /*#__PURE__*/React.createElement("img", {
      src: outlookLogo,
      width: 35,
      height: 35
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, "Outlook")), /*#__PURE__*/React.createElement(Typography, {
      className: styles.ComingSoonText
    }, "Coming soon")))),
    secondaryButtonLabel: "Cancel"
  });
}